import { useMutation, useQueryClient } from "@tanstack/react-query";
import { message } from "antd";
import { GoSync } from "react-icons/go";

import { syncJanToVeko } from "../../../../api/vehicles";
import convertToNumber from "../../../../utils/convertToNumber";
import formatCarName from "../../../../utils/formatCarName";
import extractJanUrl from "../../../../utils/extractJanUrl";

export default function SyncWidget({ car }: any) {
  const queryClient = useQueryClient();

  const { mutate, isLoading } = useMutation({
    mutationFn: syncJanToVeko,
    onError: (error) => {
      message.error(`${error}`);
    },
    onSuccess: () => {
      message.success("Updated Successfully");
      queryClient.invalidateQueries({ queryKey: ["cars", car?.carId] });
    },
  });

  const onSubmit = async () => {
    if (!car) {
      console.error("Car object is undefined.");
      return;
    }

    if (!Array.isArray(car.carImages)) {
      console.warn(
        "car.carImages is not an array or is undefined:",
        car.carImages
      );
      return;
    }

    const vimages = car?.carImages
      ?.map((image: any, index: number) => {
        if (!image || !image.imagePath) {
          console.warn(`Image at index ${index} is invalid:`, image);
          return null;
        }

        let category = "others";
        let position = `o${index + 1}`;

        if (index >= 0 && index <= 3) {
          category = "external";
          position = `e${index + 1}`;
        } else if (index >= 4 && index <= 7) {
          category = "internal";
          position = `i${index - 3}`;
        }

        return {
          url: extractJanUrl(image?.imagePath),
          isMain: index === 0,
          category,
          position,
        };
      })
      .filter(Boolean);

    if (vimages.length === 0) {
      console.warn("No valid images in car.carImages.");
      return;
    }

    const data = {
      name: formatCarName(car?.makerName || "", car?.modelName || ""),
      make: car?.makerName || "",
      model: car?.modelName || "",
      chassis: car?.chassisNo || "",
      car_id: car?.carId || "",
      country_id: 1,
      region_id: 1,
      price: car?.fobPrice || 0,
      myear: car?.registrationYear || "",
      ryear: car?.registrationYear || "",
      rmonth: car?.registrationMonth || "",
      transmission: car?.transmissionName || "",
      status: car?.cityName || "",
      drive: car?.driveName || "",
      mileage: convertToNumber(car?.mileage || 0).toString(),
      fuel_type: car?.fuelName || "",
      seats: car?.seats || 0,
      doors: car?.doors || 0,
      ex_color: car?.exteriorColor || "",
      in_color: car?.interiorColor || "",
      lot_no: car?.lotNo || "",
      main_image: extractJanUrl(car?.carImages[0]?.imagePath),
      steering: car?.steeringName || "",
      seller_id: 1,
      supplier_id: 1,
      vimages,
    };

    try {
      await mutate({ data });
    } catch (error) {
      console.error("Error during mutation:", error);
    }
  };

  return (
    <div className="mb-4">
      <div className="flex justify-between items-center border-b border-t bg-gray-100 px-2 py-3">
        <div className="">
          <span className="font-bold">VEKO</span>
          <span className="font-thin">AFRICA</span>
        </div>
      </div>
      <div className="flex justify-between p-2 text-xs">
        <div className="">Sync with Veko App</div>
        <button
          onClick={() => onSubmit()}
          className="flex items-center border px-2 py-1 text-green-600 bg-green-50"
        >
          <GoSync className="mr-1" /> {isLoading ? "Syncing..." : "Sync"}
        </button>
      </div>
    </div>
  );
}
